import { ajax } from '../ajax'


//、 授课-课中测试列表
export const reqSKTestList = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/Tjlist`, paramets)

//、 授课-课中测试详情
export const reqSKTestDetails = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/queryById_Test`, paramets)

//、 授课-课中测试结束
export const reqSKTestEnd = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/edit`, paramets, 'put')

//、 授课-课中测试推送
export const reqSKTestEdit = (paramets) => ajax(`/ClassroomTest/jxClassroomTest/updateTestStatus`, paramets, 'put')
